import defaultPlaceholder from '@/assets/default_placeholder.svg';
import { Placeholder } from '@/shared/components';
import { usePageTitle, useUserProfile } from '@/shared/hooks';

export const HomePage = () => {
  usePageTitle('Главная');

  const {
    userProfile: { first_name: firstName },
  } = useUserProfile();

  return (
    <Placeholder
      imageSrc={defaultPlaceholder}
      title={firstName}
      description="Добро пожаловать в административную панель платформы «Школа Цифровых Ролей»"
    />
  );
};
